import React from 'react';
import { Redirect } from 'react-router-dom';
import { Routes } from '~/routes/Routes';

const HomeScreen = () => {
  return <Redirect to={Routes.LOGIN} />;
};

export default HomeScreen;
